<template>
    <div class="operationLogs-container">
        <el-card class="mb16 custom-card-class">
            <div class="operationLogs-query">
                <div class="operationLogs-query-input">
                    <div class="query-input-item">
                        <span class="input-item-label"> 用户名:</span>
                        <el-input class="query-input" size="small" placeholder="请输入" v-model="query.user" clearable></el-input>
                    </div>
                    <div class="query-input-item">
                        <span class="input-item-label"> 时间范围:</span>
                        <el-date-picker size="medium" v-model="query.date" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>

                    </div>
                </div>
                <div class="operationLogs-query-btn">
                    <el-button class="query-btn" type="primary" size="small" :disabled="query.loading" @click="getData" icon="el-icon-search">查询</el-button>
                    <el-button class="query-btn cancel" plain size="small" :disabled="query.loading" @click="reset" icon="el-icon-refresh">重置</el-button>
                </div>
            </div>
        </el-card>
        <el-card>
        <div class="operationLogs-table-div">
            <el-table class="table-class" :data="table.tableData" style="width: 100%;" border header-row-class-name="header-row-class-name" header-cell-class-name="header-class-name" cell-class-name="cell-class-name">
                <el-table-column prop="operator_id" label="账户ID" width="120px"></el-table-column>
                <el-table-column prop="operator" label="用户名"  width="120px"></el-table-column>
                <el-table-column prop="operation_type" label="操作类型" width="120px"></el-table-column>
                <el-table-column prop="add_time" label="操作时间" width="180px"></el-table-column>     
                <el-table-column prop="ip_address" label="IP地址" width="180px"></el-table-column>
                <el-table-column prop="remark" label="操作描述" ></el-table-column>                
            </el-table>
            <div class="flexX pageBox flexEnd">
                <el-pagination :disabled="query.loading" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page" :page-sizes="query.pageSizesArr"
                    :page-size="query.pageSize" layout="total, sizes, prev, pager, next" :total="query.total"></el-pagination>
            </div>
        </div>
        </el-card>
    </div>
</template>
<script>

import {
		Message
	} from 'element-ui'
export default {
    data() {
        return{
            query:{
                user:'',
                date:'',                   
                page:1,
                pageSizesArr:[10,50,200,500],
                total:0,
                pageSize: 10,
                loading:false,
            },
            table:{
                tableData:[],
                height:'200px',
                
            },
        }
    },
    created() {
        this.query.date = [this.$util.timestampToTime(new Date().getTime(), true), this.$util.timestampToTime(new Date().getTime(),true)];
        this.getManagerOperators()
    },
    methods: {
        //设置表格高度
        getTableHeight(){
            this.$nextTick(() => {
                let topNav = document.getElementsByClassName('topNav')[0].offsetHeight;
                let queryBox = document.getElementsByClassName('operationLogs-query')[0].offsetHeight;
                let pageBox = document.getElementsByClassName('pageBox')[0].offsetHeight;
                let documentHeight = document.documentElement.clientHeight
                this.table.height = documentHeight - topNav - 20 - queryBox - 26 -  30 - pageBox - 70 +'px'
            })  
        },
        //查询按钮
        getData(){
            this.query.page = 1;
            this.query.total = 0;
            this.getManagerOperators()
        },
        //重置查询时间
        reset(){
            this.query.date = [this.$util.timestampToTime(new Date().getTime(), true), this.$util.timestampToTime(new Date().getTime(),true)];
            this.getData()
        },
         // 分页查询数据
         handleSizeChange(val){
            this.query.pageSize = val;
            this.query.page = 1
            this.query.total = 0
            this.getManagerOperators()
        },
        handleCurrentChange(val){
            this.query.page = val
            this.getManagerOperators()
        },
        //查询接口
        getManagerOperators(){
            this.getTableHeight()
            let data = {
                user: this.query.user,//  子账号               
                size: this.query.pageSize,
                page: this.query.page,
                startTime: this.query.date ? this.$util.timestampToTime(Date.parse(new Date(this.query.date[0])), true) : '',
                endTime: this.query.date ? this.$util.timestampToTime(Date.parse(new Date(this.query.date[1])), true) : '',
            }
            this.query.loading = true;
            this.$api.getManagerOperators(data).then(res => {
                this.query.loading = false;
                if(res.status == 1){
                    this.table.tableData = res.data.data;
                    this.query.total = res.data.total;
                }else{
                    Message({
                        message: res.msg,
                        type: 'error',
                        duration: 3 * 1000
                    });
                }
            }).catch(err => {
                this.query.loading = false;
            })
        }
    }
}
</script>
<style lang="scss">
    @import "@/style/tablestyle.scss";
    .custom-card-class{
            .el-card__body{
                padding-top:14px;
                padding-bottom:14px;
            }
        }
	// @import '@/style/variables.scss';
</style>
<style lang="scss" scoped>
.operationLogs-container{
        padding-top: 10px;
        padding-right: 10px;
    .operationLogs-query{
        padding-left:10px;
        display:flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items:center;
        .operationLogs-query-input{
            display:flex;
            flex-wrap: wrap;
            .query-input-item{
                margin-right:25px;
                display:flex;
                font-size:14px;
                align-items:center;                
                margin-bottom: 8px;
                margin-top:8px;
                .input-item-label{
                    white-space: nowrap;
                    margin-right: 10px;
                }
                .query-input{
                    width: 200px;
                    margin-left: 20px;
                }
                
            }
        }
        .operationLogs-query-btn{
            display: flex;
            margin-left: 7px;
            .query-btn{
                width: 80px;
                height: 30px;
            }
            .cancel{
                margin-left: 14px;
            }
        }
    }
    .operationLogs-table-div{
        margin-top: 31px;
        margin-left:10px;
        .table-operation{
            margin-left: 10px;
        }
        .pageBox{
            padding: 16px 20px;
            border-top: 1px solid #ebeef5;
            background-color: #fafcff;

        }
    }
}
</style>